// packages
import { geoIdentity, GeoIdentityTransform } from 'd3-geo';
import { Component, h } from 'preact';

// components
import Contest from './Contest';
import CountyTable from './CountyTable';
import HeadshotCandidateRow from './HeadshotCandidateRow';
import LayeredMap from './LayeredMap';
import Portal from './Portal';
import { PreactHTMLConverter } from 'preact-html-converter';

// utils
import { isThisIE } from '../utils/platform';
import { determineContestTitle } from '../election-utils';
import { visibleCandidatesCount } from '../endpoints';

import topology from 'Assets/geography/texas_urban.json';

const converter = PreactHTMLConverter();

const isIE = isThisIE();

interface ContestShowcaseProps {
  container: Element;
  contest: any | null;
  asOf: string;
  visibleCandidatesCount?: number;
  annotations: { [key: string]: any };
}

interface ContestShowcaseState {
  contestContainer: Element;
  mapContainer: Element;
  countiesContainer: Element;
}

class ContestShowcase extends Component<
  ContestShowcaseProps,
  ContestShowcaseState
> {
  projection: GeoIdentityTransform;

  constructor() {
    super();

    this.projection = geoIdentity().reflectY(true);
    
  }

  componentDidMount() {
    const { container } = this.props;

    const contestContainer = container.querySelector('.contest-container');
    const mapContainer = container.querySelector('.contest-map-container');
    const countiesContainer = container.querySelector(
      '.contest-counties-container'
    );

    this.setState({ contestContainer, mapContainer, countiesContainer });
  }

  render() {
    const { contest, annotations, asOf } = this.props;
    const { contestContainer, mapContainer, countiesContainer } = this.state;


    if (!contest) return null;

    return (
      <span>
        {contestContainer && (
          <Portal
            node={contestContainer}
            ref={ref => (this._contestPortal = ref)}
          >
            <Contest
              contest={contest}
              contestTitle={determineContestTitle(contest)}
              isShowcaseRace
              annotations={annotations}
              tableHeader={HeadshotCandidateRow.Header}
              columnCount={HeadshotCandidateRow.columnCount}
              visibleCandidateCount={visibleCandidatesCount}
              asOf={asOf}
              renderCandidate={(
                candidate: any,
                idx: number,
                viewAllCandidates: any,
                { totalVotes }: { totalVotes: number }
              ) => (
                <HeadshotCandidateRow
                  key={candidate.id}
                  ballotName={candidate.name}
                  candidateId={candidate.id}
                  contestIsCalled={contest.is_called}
                  isIncumbent={candidate.is_incumbent}
                  isWinner={candidate.is_winner}
                  isViewable={viewAllCandidates || idx < visibleCandidatesCount}
                  party={candidate.party}
                  totalVotesInContest={totalVotes}
                  votes={candidate.votes}
                />
              )}
            />
          </Portal>
        )}
        {!isIE && mapContainer && (
          <Portal node={mapContainer} ref={ref => (this._mapPortal = ref)}>
            <LayeredMap
              topology={topology}
              projection={this.projection}
              candidates={contest.candidacies}
              counties={contest.counties}
              precinctsReporting={contest.precincts_reporting}
              totalVotes={contest.total_votes}
            />
          </Portal>
        )}
        {/* {!isIE &&
          countiesContainer && (
            <Portal
              node={countiesContainer}
              ref={ref => (this._countiesPortal = ref)}
            >
              <CountyTable
                candidates={contest.candidates}
                counties={contest.counties}
              />
            </Portal>
          )} */}
      </span>
    );
  }
}

export default ContestShowcase;
